<template>
    <b-tabs
        class="apprentice-pills-tab group-show-tools-tab"
        v-model="activeTab"
        pills
        vertical
        nav-wrapper-class="col-12 col-lg-3 col-xl-2 d-none d-lg-block"
        content-class="col-12 col-lg-9 col-xl-10 group-show-tools-tab-content"
        @input="updateTabIndex">
        <div class="group-show-tools-sub-item-nav d-flex d-lg-none">
            <b-form-select
                class="apprentice-primary-select"
                v-model="activeTab"
                :options="options"></b-form-select>
        </div>

        <b-tab
            title="Agenda"
            title-item-class="tools-tab-item"
            title-link-class="tools-tab-item-link">
            <template v-slot:title>
                <div class="tab-title">
                    <div class="title"><i class="fas fa-calendar-alt fa-fw"></i>Agenda</div>
                </div>
            </template>

            <div>
                <design-2021-group-calendar-component
                    :group-id="groupId"
                    :agenda-items-in="agendaItemsIn"
                    :is-student="isStudent"
                    :is-group-admin="permissions.coordinator">
                </design-2021-group-calendar-component>
            </div>
        </b-tab>

        <b-tab
            :title="$t('group.files')"
            title-item-class="tools-tab-item"
            title-link-class="tools-tab-item-link">
            <template v-slot:title>
                <div class="tab-title">
                    <div class="title"><i class="fas fa-file-alt fa-fw"></i>{{ $t('group.files') }}</div>
                </div>
            </template>

            <div>
                <design-2021-group-file-component
                    :group-id="groupId"
                    :files-in="filesIn"></design-2021-group-file-component>
            </div>
        </b-tab>

        <b-tab
            :title="$t('group.messages')"
            title-item-class="tools-tab-item"
            title-link-class="tools-tab-item-link">
            <template v-slot:title>
                <div class="tab-title">
                    <div class="title"><i class="fad fa-envelope fa-fw"></i>{{ $t('group.messages') }}</div>
                </div>
            </template>

            <div>
                <design-2021-project-show-message-component
                    :project-type-id="groupId"
                    :messages-in="messagesIn"
                    message-type="group"
                    :is-student="isStudent"
                    :profile-image-in="profileImageIn"
                    :advanced-option="true">
                </design-2021-project-show-message-component>
            </div>
        </b-tab>
    </b-tabs>
</template>

<script>
export default {
    name: 'design-2021-group-tools-component',
    props: [
        'groupId',
        'filesIn',
        'messagesIn',
        'agendaItemsIn',
        'isStudent',
        'isTeacher',
        'groupMessagesCount',
        'profileImageIn',
        'permissions',
        'groupTypeId',
    ],
    data() {
        return {
            activeTab: 0,
            options: [
                { value: 0, text: 'Agenda' },
                { value: 1, text: this.$t('group.files') },
                { value: 2, text: this.$t('group.messages') },
            ],
        };
    },
    methods: {
        updateTabIndex(tabIndex) {
            const name = `session-${this.$authUser.id}-group-${this.groupId}-ToolsTab`;
            localStorage.setItem(name, tabIndex);
        },
    },
    created() {
        const name = `session-${this.$authUser.id}-group-${this.groupId}-ToolsTab`;
        if (localStorage.getItem(name)) {
            this.activeTab = parseInt(localStorage.getItem(name));
        }
    },
};
</script>

<style scoped lang="scss">
.tools-messages-count.messages-count-bubble {
    padding: 1px 3px;
    margin-left: 8px;
    height: 21px;
    width: 21px;
}

.group-show-tools-sub-item-nav {
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
    display: flex;
    align-items: center;
    justify-content: flex-end;

    select {
        width: auto;
            border: 1px solid var(--primary);
    }
}
</style>
